// extracted by mini-css-extract-plugin
export var icon = "_sl-0";